/* Interaction events for leg A. Load in theme.liquid with:
     <script src="{{ 'gtm-events.js' | asset_url }}" defer></script>

   Covers: select_item, add_to_cart, remove_from_cart, add_to_wishlist,
   view_promotion, select_promotion, sign_up, login, generate_lead, size_guide_open.
   view_item / view_item_list / view_cart / search come from gtm-datalayer.liquid.
   file_download needs no theme code — GTM's 'PDF click' trigger handles it.

   MARKUP CONTRACT. This file reads data attributes rather than guessing at class
   names, so the theme has to opt in:
     product card   data-track-item='{"item_id":"SKU","item_name":"…","price":0,"index":0}'
                    data-track-list-id="collection-handle"
     promo banner   data-track-promo='{"promotion_id":"…","promotion_name":"…","creative_slot":"…"}'
     wishlist btn   data-track-wishlist='{"item_id":"SKU","item_name":"…","price":0}'
     size guide     data-track-size-guide="SKU"
     newsletter     data-track-lead='{"lead_source":"footer","form_id":"newsletter"}'
*/
(function () {
  'use strict';
  var dl = function (o) { (window.dataLayer = window.dataLayer || []).push(o); };
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NOK';

  /* ── GA4 identity -> cart attributes ──────────────────────────────────────────
   * Checkout and purchase CANNOT be tracked from the browser: Shopify's Web Pixel
   * sandbox blocks all outbound requests (proven 2026-09-17 — an identical
   * Measurement Protocol payload arrived from a laptop and never from the pixel).
   * So purchase is sent server-side instead, by a Shopify Flow workflow on
   * "Order created".
   *
   * Flow runs on the server and cannot see the _ga cookies, so without help every
   * purchase would land in GA4 as a brand-new user attributed to (direct) —
   * revenue with no channel. This copies the GA4 client_id and session_id onto the
   * cart, where they survive into the order and Flow can read them back.
   *
   * The theme is NOT sandboxed, which is the only reason this works.
   */
  var GA4_SESSION_COOKIE = '_ga_YLLSY8BCHC';

  function cookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : null;
  }

  // _ga is "GA1.1.<a>.<b>"; GA4 wants "<a>.<b>".
  function clientId() {
    var raw = cookie('_ga');
    if (!raw) { return null; }
    var parts = String(raw).split('.');
    return parts.length >= 4 ? parts[2] + '.' + parts[3] : null;
  }

  // Two formats in the wild. Legacy: GS1.1.<sid>.<n>...  Current: GS2.1.s<sid>$o<n>$...
  function sessionId() {
    var raw = cookie(GA4_SESSION_COOKIE);
    if (!raw) { return null; }
    var seg = String(raw).split('.')[2];
    if (!seg) { return null; }
    if (seg.charAt(0) === 's') { seg = seg.slice(1); }
    var dollar = seg.indexOf('$');
    if (dollar > -1) { seg = seg.slice(0, dollar); }
    return seg || null;
  }

  /* Three carriers, because no single one survives every checkout path.
   *
   *   A. CART ATTRIBUTES  — normal cart -> checkout. Written by stampCart().
   *   B. LINE ITEM PROPS  — "Buy it now" and the accelerated buttons build a checkout
   *                         straight from the product form, so no cart ever exists and
   *                         there are no cart attributes to carry. A hidden
   *                         properties[_ga4_cid] input rides with the line item into
   *                         the order instead. Underscore prefix keeps it hidden from
   *                         the customer on the order page and in emails.
   *   C. KEEPALIVE ON CLICK — an express button can redirect before an in-flight
   *                         stamp resolves. keepalive:true lets the POST outlive the
   *                         navigation.
   *
   * Roughly 80% of Skogstad's orders go through Klarna/Vipps express (measured: 331
   * begin_checkout against 1,577 purchases), so B and C are not edge cases — they are
   * the majority path, and the reason purchases were landing unattributed.
   */
  var lastStamp = null;

  function identityMark() {
    var cid = clientId();
    if (!cid) { return null; }                  // consent denied or GA4 not loaded yet
    return { cid: cid, sid: sessionId() || '' };
  }

  // A + C. cartToken is part of the guard: a new cart needs a new stamp even when the
  // identity is unchanged, which the old identity-only guard silently suppressed.
  function stampCart(opts) {
    var id = identityMark();
    if (!id) { return; }
    var token = (document.cookie.match(/(^|;)\s*cart\s*=\s*([^;]+)/) || [])[2] || '';
    var mark = id.cid + '|' + id.sid + '|' + token;
    if (!(opts && opts.force) && mark === lastStamp) { return; }
    lastStamp = mark;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: !!(opts && opts.keepalive),
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ga4_client_id: id.cid, ga4_session_id: id.sid } })
    }).catch(function (err) {
      lastStamp = null;                          // let the next trigger retry
      console.warn('[tracking] could not stamp cart with GA4 identity', err);
    });
  }

  // B. Product forms post to /cart/add even on the dynamic checkout path, so a hidden
  // property here is the only carrier that survives "Buy it now".
  function stampProductForms() {
    var id = identityMark();
    if (!id) { return; }
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      setProp(forms[i], '_ga4_cid', id.cid);
      setProp(forms[i], '_ga4_sid', id.sid);
    }
  }

  function setProp(form, key, value) {
    var name = 'properties[' + key + ']';
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function stampAll(opts) { stampCart(opts); stampProductForms(); }

  // Express buttons often sit in a cross-origin iframe, so the click itself is not
  // observable. Capture-phase pointerdown on the surrounding container is — and it
  // fires before the redirect starts.
  var EXPRESS = '.shopify-payment-button, shopify-accelerated-checkout, ' +
                'shopify-accelerated-checkout-cart, [data-shopify="payment-button"], ' +
                '[name="checkout"], form[action*="/checkout"]';
  document.addEventListener('pointerdown', function (e) {
    var el = e.target;
    for (; el && el !== document; el = el.parentNode) {
      if (el.matches && el.matches(EXPRESS)) {
        stampAll({ force: true, keepalive: true });
        return;
      }
    }
  }, true);

  // Re-stamp whenever the cart changes — a new cart token invalidates the old stamp.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
      stampProductForms();
    }
  }, true);

  // GA4 sets _ga on its first hit, which may land after this file runs, and the cookie
  // only exists at all once consent is granted — so retry on consent change.
  if (document.readyState !== 'loading') { stampAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { stampAll(); }, false); }
  window.addEventListener('CookieInformationConsentGiven', function () {
    setTimeout(function () { stampAll({ force: true }); }, 1000);
  }, false);

  function parse(el, attr) {
    try { return JSON.parse(el.getAttribute(attr)); }
    catch (e) { console.warn('[tracking] bad JSON in ' + attr, el); return null; }
  }

  function closestWith(el, attr) {
    for (; el && el !== document; el = el.parentNode) {
      if (el.getAttribute && el.getAttribute(attr) !== null) { return el; }
    }
    return null;
  }

  /* ── select_item ─────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var card = closestWith(e.target, 'data-track-item');
    if (!card) { return; }
    var item = parse(card, 'data-track-item');
    if (!item) { return; }
    var listId = card.getAttribute('data-track-list-id') || undefined;
    dl({
      event: 'select_item',
      ecommerce: {
        currency: CURRENCY,
        item_list_id: listId,
        items: [item]
      }
    });
  }, true);

  /* ── select_promotion / view_promotion ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var banner = closestWith(e.target, 'data-track-promo');
    if (!banner) { return; }
    var promo = parse(banner, 'data-track-promo');
    if (promo) { dl({ event: 'select_promotion', ecommerce: promo }); }
  }, true);

  if ('IntersectionObserver' in window) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) { return; }
        seen.add(entry.target);
        var promo = parse(entry.target, 'data-track-promo');
        if (promo) { dl({ event: 'view_promotion', ecommerce: promo }); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-track-promo]').forEach(function (el) { io.observe(el); });
  }

  /* ── add_to_wishlist ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = closestWith(e.target, 'data-track-wishlist');
    if (!btn) { return; }
    var item = parse(btn, 'data-track-wishlist');
    if (!item) { return; }
    dl({
      event: 'add_to_wishlist',
      ecommerce: { currency: CURRENCY, value: item.price, items: [item] }
    });
  }, true);

  /* ── size_guide_open ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var el = closestWith(e.target, 'data-track-size-guide');
    if (!el) { return; }
    dl({ event: 'size_guide_open', item_id: el.getAttribute('data-track-size-guide') });
  }, true);

  /* ── generate_lead ───────────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = closestWith(e.target, 'data-track-lead');
    if (!form) { return; }
    var meta = parse(form, 'data-track-lead') || {};
    dl({ event: 'generate_lead', lead_source: meta.lead_source, form_id: meta.form_id });
  }, true);

  /* ── add_to_cart / remove_from_cart ──────────────────────────────────────────
     Shopify themes mutate the cart through /cart/add.js, /cart/change.js and
     /cart/update.js. Wrapping fetch is the only reliable hook that survives theme
     differences and works for the cart drawer as well as the cart page.
     Both XHR and fetch are covered because some apps still use XHR.             */
  var CART_ADD = /\/cart\/add(\.js)?/;
  var CART_CHANGE = /\/cart\/(change|update)(\.js)?/;

  function afterCartMutation(url, requestBody) {
    // Re-read the cart so quantities and prices are authoritative rather than guessed.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var currency = cart.currency || CURRENCY;
        if (CART_ADD.test(url)) {
          var added = lastAdded(cart, requestBody);
          if (!added) { return; }
          dl({
            event: 'add_to_cart',
            ecommerce: {
              currency: currency,
              value: (added.final_price || 0) / 100,
              items: [lineToItem(added, 1)]
            }
          });
        } else if (CART_CHANGE.test(url)) {
          var delta = quantityDelta(cart);
          if (!delta) { return; }
          dl({
            event: delta.removed ? 'remove_from_cart' : 'add_to_cart',
            ecommerce: {
              currency: currency,
              value: Math.abs(delta.value) / 100,
              items: [delta.item]
            }
          });
        }
        snapshot(cart);
      })
      .catch(function (err) { console.warn('[tracking] /cart.js read failed', err); });
  }

  function lineToItem(line, qty) {
    return {
      // Must match the Merchant Center feed id, not the SKU — see FEED_ID_PREFIX in
      // gen_theme_snippets.py. /cart.js gives product_id and variant_id directly.
      item_id: 'shopify_ZZ_' + line.product_id + '_' + line.variant_id,
      item_sku: line.sku || null,
      item_name: line.product_title,
      item_brand: line.vendor,
      item_variant: line.variant_title,
      price: (line.final_price || 0) / 100,
      quantity: qty || line.quantity
    };
  }

  function lastAdded(cart, requestBody) {
    // Match on the variant id we just posted, so the right line is reported even
    // when the cart already contained it.
    var id = null;
    try {
      if (typeof requestBody === 'string') {
        var m = requestBody.match(/(?:^|&)id=(\d+)/);
        if (m) { id = m[1]; }
        else { var j = JSON.parse(requestBody); id = j && (j.id || (j.items && j.items[0] && j.items[0].id)); }
      }
    } catch (e) { /* form-encoded or opaque body — fall through */ }
    if (!id) { return cart.items && cart.items[cart.items.length - 1]; }
    return (cart.items || []).filter(function (l) { return String(l.variant_id) === String(id); })[0];
  }

  var prev = {};
  function snapshot(cart) {
    prev = {};
    (cart.items || []).forEach(function (l) { prev[l.variant_id] = l; });
  }

  function quantityDelta(cart) {
    var now = {};
    (cart.items || []).forEach(function (l) { now[l.variant_id] = l; });
    var ids = Object.keys(prev).concat(Object.keys(now));
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      var before = prev[id] ? prev[id].quantity : 0;
      var after = now[id] ? now[id].quantity : 0;
      if (before === after) { continue; }
      var line = now[id] || prev[id];
      var diff = after - before;
      return {
        removed: diff < 0,
        value: (line.final_price || 0) * diff,
        item: lineToItem(line, Math.abs(diff))
      };
    }
    return null;
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var body = (init && init.body) || null;
      return origFetch.apply(this, arguments).then(function (res) {
        if (CART_ADD.test(url) || CART_CHANGE.test(url)) {
          afterCartMutation(url, typeof body === 'string' ? body : null);
        }
        return res;
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__trackUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var self = this;
    this.addEventListener('load', function () {
      var url = self.__trackUrl || '';
      if (CART_ADD.test(url) || CART_CHANGE.test(url)) {
        afterCartMutation(url, typeof body === 'string' ? body : null);
      }
    });
    return origSend.apply(this, arguments);
  };

  // Seed the snapshot so the first change event has something to diff against.
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(snapshot)
    .catch(function () { /* empty cart or blocked — nothing to seed */ });

  /* ── sign_up / login ─────────────────────────────────────────────────────────
     Shopify redirects after both, so these are emitted from the landing page via
     a flag the account templates set. See INSTALL.md.                          */
  var flag = window.__trackAccountEvent;
  if (flag === 'sign_up' || flag === 'login') {
    dl({ event: flag, method: 'shopify' });
  }
})();
